"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Joystick_1 = require("./Joystick");
exports.Joystick = Joystick_1.Joystick;
//# sourceMappingURL=index.js.map